const INITIAL_STATE = {
  notifications: [],
  reminders: [],
};

/**
 * Types
 */
export const Types = {
  GET_NOTIFICATIONS_REQUEST: 'notification/GET_NOTIFICATIONS_REQUEST',
  GET_NOTIFICATIONS_SUCCESS: 'notification/GET_NOTIFICATIONS_SUCCESS',
  SET_NOTIFICATIONS_CONCLUDE_REQUEST: 'notification/SET_NOTIFICATIONS_CONCLUDE_REQUEST',
  SET_NOTIFICATIONS_CONCLUDE_SUCCESS: 'notification/SET_NOTIFICATIONS_CONCLUDE_SUCCESS',
  POST_NOTIFICATIONS_REQUEST: 'notification/POST_NOTIFICATIONS_REQUEST',
  PUT_NOTIFICATIONS_REQUEST: 'notification/PUT_NOTIFICATIONS_REQUEST',
  DELETE_NOTIFICATIONS_REQUEST: 'notification/DELETE_NOTIFICATIONS_REQUEST',
  DELETE_NOTIFICATIONS_SUCCESS: 'notification/DELETE_NOTIFICATIONS_SUCCESS',
  DISPLAY_NOTIFICATION: 'notification/DISPLAY_NOTIFICATION',
};

/**
 * Reducer
 */
export default function notificationResponsibility(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_NOTIFICATIONS_SUCCESS: {
      return { ...state, reminders: action.payload };
    }
    case Types.SET_NOTIFICATIONS_CONCLUDE_SUCCESS: {
      return {
        ...state,
        reminders: state.reminders.filter(notification => (
          notification.id !== action.payload.id
        )),
      };
    }
    case Types.DELETE_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        reminders: state.reminders.filter(notification => (
          notification.id !== action.payload.id
        )),
      };
    }
    case Types.DISPLAY_NOTIFICATION: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getNotificationsRequest: user_id => ({
    type: Types.GET_NOTIFICATIONS_REQUEST,
    payload: {
      user_id,
    },
  }),
  getNotificationsSuccess: payload => ({
    type: Types.GET_NOTIFICATIONS_SUCCESS,
    payload,
  }),
  setNotificationsConcludeRequest: payload => ({
    type: Types.SET_NOTIFICATIONS_CONCLUDE_REQUEST,
    payload,
  }),
  setNotificationsConcludeSuccess: payload => ({
    type: Types.SET_NOTIFICATIONS_CONCLUDE_SUCCESS,
    payload,
  }),
  postNotificationsRequest: payload => ({
    type: Types.POST_NOTIFICATIONS_REQUEST,
    payload,
  }),
  putNotificationsRequest: payload => ({
    type: Types.PUT_NOTIFICATIONS_REQUEST,
    payload,
  }),
  deleteNotificationsRequest: payload => ({
    type: Types.DELETE_NOTIFICATIONS_REQUEST,
    payload,
  }),
  deleteNotificationsSuccess: notification_id => ({
    type: Types.DELETE_NOTIFICATIONS_SUCCESS,
    payload: {
      id: notification_id,
    },
  }),
  displayNotification: payload => ({
    type: Types.DISPLAY_NOTIFICATION,
    payload,
  }),
};
